import React, { Fragment } from 'react'
import { Routes, AppRoutes } from './AppRoutes'
import Debug from 'components/Debug'
import Player from 'components/Player'
import { getKey } from 'utils'

const AppView = () => (
  <Fragment>
    {(process.env.NODE_ENV === 'development' || window.location.hostname === 'virgin-htmltv-dot-hopster-dev.appspot.com') && <Debug />}
    <Player />
    {Routes().map(route => (
      <AppRoutes key={getKey()} {...route} />
    ))}
  </Fragment>
)

export default AppView
